import axios from 'axios';
import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';
import CartController from './cart-controller';
export default class CheckoutForm extends Component {
	constructor({ url = 'submitform' }) {
		super({
			element: '.popup__shipping-details',
			elements: {},
		});

		this.elements.btn = document.querySelector('#checkout');
		this.formUrl = url;
		this.timer = null;
		this.timeSteps = 0;
		this.reqAttempts = 0;
	}

	create() {
		super.createComponent();
		this.elements.btn = document.querySelector('#checkout');
		console.log(this.element);
	}

	errorTimer() {
		if (this.reqAttempts > 2) {
			this.elements.btn.textContent = 'Try again later';
			return;
		}
		this.timer = setInterval(() => {
			this.timeSteps++;
			if (this.timeSteps > 5) {
				clearInterval(this.timer);
				this.animate('default');
				this.reqAttempts += 1;
				this.timer = null;
				this.timeSteps = 0;
			} else {
				this.elements.btn.textContent = `Error! (${6 - this.timeSteps})`;
			}
		}, 1000);
	}

	animate(e) {
		this.elements.btn.classList.add('btn--disabled');
		switch (e) {
			case 'loading':
				this.elements.btn.textContent = 'Loading...';
				break;
			case 'success':
				this.elements.btn.textContent = 'Order Created!';
				this.elements.btn.classList.add('btn--success');
				break;
			case 'error':
				this.elements.btn.textContent = 'Error!';
				this.elements.btn.classList.add('btn--error');
				this.errorTimer();
				break;
			case 'default':
				this.elements.btn.classList.remove('btn--disabled');
				this.elements.btn.classList.remove('btn--success');
				this.elements.btn.classList.remove('btn--error');
				this.elements.btn.textContent = 'Confirm Order';
				break;
			default:
				break;
		}
	}

	submitForm(e) {
		e.preventDefault();
		this.animate('loading');

		// Get data from form and add it to an object
		const finalData = {};
		const formData = new FormData(this.element);

		[...formData].map((info) => {
			finalData[info[0]] = info[1];
		});

		const cartItems = CartController.getCartItems();
		finalData.products = cartItems;
		finalData.delivery = CartController.getDeliveryPrice();
		finalData.deliverystring = CartController.getDeliveryPriceString();
		finalData.subtotal = CartController.getSubtotalPrice();
		finalData.subtotalstring = CartController.getSubtotalPriceString();
		finalData.total = CartController.getTotalPrice();
		finalData.totalstring = CartController.getTotalPriceString();
		finalData.locale = window.locale;

		console.log(finalData);

		// if (!finalData.name || !finalData.email) {
		// 	return this.animate('default');
		// }

		// Send the object via axios
		this.sendData(finalData);
	}

	requestSubmitForm() {
		this.element.requestSubmit();
	}
	async sendData(data) {
		try {
			const res = await axios.post(`${this.formUrl}`, { order: data });
			// open res.pageUrl
			window.open(res.data.pageUrl, '_self');
			// window.location.href = res.data.pageUrl;
			// window.location.replace(res.data.pageUrl);
			this.animate('success');
		} catch (error) {
			console.error(error.message);
			this.animate('error');
		}
	}

	addEventListeners() {
		this.element.addEventListener('submit', (e) => this.submitForm(e));
	}

	// removeEventListeners() {
	// 	this.element.removeEventListener('submit', (e) => this.submitForm(e));
	// }

	destroy() {
		GSAP.killTweensOf(this.elements.left);
	}
}
